import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  REPORTS_FETCH_SUMMARY_DATA_BY_REGION_BEGIN,
  REPORTS_FETCH_SUMMARY_DATA_BY_REGION_SUCCESS,
  REPORTS_FETCH_SUMMARY_DATA_BY_REGION_FAILURE,
  REPORTS_FETCH_SUMMARY_DATA_BY_REGION_DISMISS_ERROR,
} from './constants';

export function fetchSummaryDataByRegion(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: REPORTS_FETCH_SUMMARY_DATA_BY_REGION_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      let conditions = args;
      if(args.sortedBy === undefined || args.sortedBy === null) {
        conditions = {
          ...conditions,
          sort: "ascend",
          sortedBy: "region",
        }
      }
      const doRequest = axios.post(`${API_REQUEST_URL}/getSalesSummaryRegionReport`, args, {
        headers: {
          'Authorization': token,
        }
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: REPORTS_FETCH_SUMMARY_DATA_BY_REGION_SUCCESS,
            data: {
              data: res.data.data,
              totals: res.data.totals,
              summary: res.data && res.data.summary,
            },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: REPORTS_FETCH_SUMMARY_DATA_BY_REGION_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchSummaryDataByRegionError() {
  return {
    type: REPORTS_FETCH_SUMMARY_DATA_BY_REGION_DISMISS_ERROR,
  };
}

export function useFetchSummaryDataByRegion() {
  const dispatch = useDispatch();

  const { reportsRegionData,reportsRegionTotals,regionSummary,fetchSummaryDataByRegionPending, fetchSummaryDataByRegionError } = useSelector(
    state => ({
      reportsRegionData: state.reports.reportsRegionData,
      reportsRegionTotals: state.reports.reportsRegionTotals,
      regionSummary: state.reports.regionSummary,
      fetchSummaryDataByRegionPending: state.reports.fetchSummaryDataByRegionPending,
      fetchSummaryDataByRegionError: state.reports.fetchSummaryDataByRegionError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchSummaryDataByRegion(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchSummaryDataByRegionError());
  }, [dispatch]);

  return {
    reportsRegionData,
    reportsRegionTotals,
    regionSummary,
    fetchSummaryDataByRegion: boundAction,
    fetchSummaryDataByRegionPending,
    fetchSummaryDataByRegionError,
    dismissFetchSummaryDataByRegionError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case REPORTS_FETCH_SUMMARY_DATA_BY_REGION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchSummaryDataByRegionPending: true,
        fetchSummaryDataByRegionError: null,
      };

    case REPORTS_FETCH_SUMMARY_DATA_BY_REGION_SUCCESS:
      // The request is success
      return {
        ...state,
        reportsRegionData: action.data.data,
        reportsRegionTotals: action.data.totals,
        regionSummary: action.data.summary,
        fetchSummaryDataByRegionPending: false,
        fetchSummaryDataByRegionError: null,
      };

    case REPORTS_FETCH_SUMMARY_DATA_BY_REGION_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchSummaryDataByRegionPending: false,
        fetchSummaryDataByRegionError: action.data.error,
      };

    case REPORTS_FETCH_SUMMARY_DATA_BY_REGION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchSummaryDataByRegionError: null,
      };

    default:
      return state;
  }
}
